import { render, staticRenderFns } from "./userLogout.vue?vue&type=template&id=03589f81&scoped=true"
import script from "./userLogout.vue?vue&type=script&lang=js"
export * from "./userLogout.vue?vue&type=script&lang=js"
import style0 from "./userLogout.vue?vue&type=style&index=0&id=03589f81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03589f81",
  null
  
)

export default component.exports